import { render, staticRenderFns } from "./email-templates-card.vue?vue&type=template&id=f384b52c&"
import script from "./email-templates-card.vue?vue&type=script&lang=ts&"
export * from "./email-templates-card.vue?vue&type=script&lang=ts&"
import style0 from "./email-templates-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports